import { useEffect, useState } from 'react';
import { AdminSidebar, Icon, Modal, StatusBadge, Pagination, formatDate } from '../../components/shared';
import api from '../../services/api';
import toast from 'react-hot-toast';

const API = process.env.REACT_APP_API_BASE || 'http://localhost:3001';

const EMPTY = {
  razao_social:'', nome_fantasia:'', cnpj_cpf:'', telefone:'', email:'',
  endereco:'', numero:'', bairro:'', complemento:'', cidade:'', estado:'', cep:'',
  nome_admin:'', email_admin:'', senha_admin:'', slug:'',
};

export default function MasterEmpresas() {
  const [empresas, setEmpresas]   = useState([]);
  const [total, setTotal]         = useState(0);
  const [page, setPage]           = useState(1);
  const [loading, setLoading]     = useState(true);
  const [busca, setBusca]         = useState('');
  const [statusFiltro, setStatus] = useState('');
  const [modal, setModal]         = useState(false);
  const [editing, setEditing]     = useState(null);
  const [form, setForm]           = useState(EMPTY);
  const [logoFile, setLogoFile]   = useState(null);
  const [saving, setSaving]       = useState(false);

  const carregar = async () => {
    setLoading(true);
    try {
      const params = { page, limit: 15, busca, status: statusFiltro };
      const { data } = await api.get('/empresas', { params });
      setEmpresas(data.dados); setTotal(data.total);
    } catch { toast.error('Erro ao carregar empresas'); }
    finally { setLoading(false); }
  };

  useEffect(() => { carregar(); }, [page, busca, statusFiltro]);

  const abrirNovo = () => { setForm(EMPTY); setEditing(null); setLogoFile(null); setModal(true); };
  const abrirEditar = (e) => {
    setForm({ ...e, nome_admin:'', email_admin:'', senha_admin:'' });
    setEditing(e); setLogoFile(null); setModal(true);
  };

  const salvar = async () => {
    setSaving(true);
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k, v]) => { if (v) fd.append(k, v); });
      if (logoFile) fd.append('logo', logoFile);
      if (editing) {
        await api.put(`/empresas/${editing.id}`, fd);
        toast.success('Empresa atualizada!');
      } else {
        await api.post('/empresas', fd);
        toast.success('Empresa criada!');
      }
      setModal(false); carregar();
    } catch (err) { toast.error(err.response?.data?.erro || 'Erro ao salvar'); }
    finally { setSaving(false); }
  };

  const alterarStatus = async (id, status) => {
    try {
      await api.patch(`/empresas/${id}/status`, { status });
      toast.success('Status atualizado!'); carregar();
    } catch { toast.error('Erro ao alterar status'); }
  };

  const F = (k, v) => setForm(p => ({ ...p, [k]: v }));

  return (
    <div className="admin-layout">
      <AdminSidebar perfil="master" />
      <div className="main-content">
        <div className="topbar">
          <h1>Empresas</h1>
          <button className="btn btn-primary" onClick={abrirNovo}>
            <Icon name="plus" size={16} /> Nova Empresa
          </button>
        </div>
        <div className="page-content">
          <div className="table-card">
            <div className="table-header">
              <div className="filter-bar">
                <div className="search-input">
                  <Icon name="search" />
                  <input className="form-control" placeholder="Buscar empresa..." value={busca}
                    onChange={e => { setBusca(e.target.value); setPage(1); }}
                    style={{ width: '220px', paddingLeft: '34px' }} />
                </div>
                <select className="form-control" value={statusFiltro}
                  onChange={e => { setStatus(e.target.value); setPage(1); }}
                  style={{ width: '140px' }}>
                  <option value="">Todos status</option>
                  <option value="ativa">Ativa</option>
                  <option value="inativa">Inativa</option>
                  <option value="bloqueada">Bloqueada</option>
                </select>
              </div>
              <span style={{ fontSize: '.8rem', color: 'var(--text-muted)' }}>{total} empresa(s)</span>
            </div>

            {loading ? <div className="loading-center"><div className="spinner" /></div> : (
              <div className="table-wrapper">
                <table>
                  <thead>
                    <tr><th>Empresa</th><th>CNPJ/CPF</th><th>Cidade</th><th>Status</th><th>Criado em</th><th>Ações</th></tr>
                  </thead>
                  <tbody>
                    {empresas.map(e => (
                      <tr key={e.id}>
                        <td>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            {e.logo_url
                              ? <img src={`${API}${e.logo_url}`} alt="" style={{ width: 32, height: 32, borderRadius: '6px', objectFit: 'cover' }} />
                              : <div style={{ width: 32, height: 32, borderRadius: '6px', background: 'var(--primary-light)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1rem' }}>🏪</div>
                            }
                            <div>
                              <div style={{ fontWeight: 600 }}>{e.nome_fantasia}</div>
                              <div style={{ fontSize: '.75rem', color: 'var(--text-muted)' }}>{e.razao_social}</div>
                            </div>
                          </div>
                        </td>
                        <td style={{ fontFamily: 'monospace', fontSize: '.85rem' }}>{e.cnpj_cpf}</td>
                        <td>{e.cidade}/{e.estado}</td>
                        <td><StatusBadge status={e.status} /></td>
                        <td>{formatDate(e.criado_em)}</td>
                        <td>
                          <div style={{ display: 'flex', gap: '6px' }}>
                            <button className="btn btn-icon btn-sm" onClick={() => abrirEditar(e)} title="Editar"><Icon name="edit" size={14} /></button>
                            {e.status !== 'ativa' && <button className="btn btn-success btn-sm" onClick={() => alterarStatus(e.id, 'ativa')}>Ativar</button>}
                            {e.status === 'ativa' && <button className="btn btn-danger btn-sm" onClick={() => alterarStatus(e.id, 'inativa')}>Inativar</button>}
                          </div>
                        </td>
                      </tr>
                    ))}
                    {!empresas.length && <tr><td colSpan={6}><div className="empty-state"><Icon name="building" /><h3>Nenhuma empresa encontrada</h3></div></td></tr>}
                  </tbody>
                </table>
              </div>
            )}
            <div className="table-footer">
              <span>Mostrando {empresas.length} de {total}</span>
              <Pagination page={page} total={total} limit={15} onChange={setPage} />
            </div>
          </div>
        </div>
      </div>

      <Modal open={modal} onClose={() => setModal(false)} title={editing ? 'Editar Empresa' : 'Nova Empresa'} size="modal-lg">
        <div className="modal-body" style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
          <h4 style={{ color: 'var(--text-muted)', fontSize: '.8rem', textTransform: 'uppercase', letterSpacing: 1 }}>Dados da Empresa</h4>
          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Razão Social *</label>
              <input className="form-control" value={form.razao_social} onChange={e => F('razao_social', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">Nome Fantasia *</label>
              <input className="form-control" value={form.nome_fantasia} onChange={e => F('nome_fantasia', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">CNPJ/CPF *</label>
              <input className="form-control" value={form.cnpj_cpf} onChange={e => F('cnpj_cpf', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">Telefone</label>
              <input className="form-control" value={form.telefone} onChange={e => F('telefone', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">Email</label>
              <input className="form-control" type="email" value={form.email} onChange={e => F('email', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">CEP</label>
              <input className="form-control" value={form.cep} onChange={e => F('cep', e.target.value)} />
            </div>
            <div className="form-group" style={{ gridColumn: 'span 2' }}>
              <label className="form-label">Endereço</label>
              <input className="form-control" value={form.endereco} onChange={e => F('endereco', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">Número</label>
              <input className="form-control" value={form.numero} onChange={e => F('numero', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">Bairro</label>
              <input className="form-control" value={form.bairro} onChange={e => F('bairro', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">Cidade</label>
              <input className="form-control" value={form.cidade} onChange={e => F('cidade', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">Estado</label>
              <input className="form-control" value={form.estado} onChange={e => F('estado', e.target.value)} maxLength={2} />
            </div>
            <div className="form-group" style={{ gridColumn: 'span 2' }}>
              <label className="form-label">
                Slug do Cardápio
                <span style={{ fontWeight: 400, color: 'var(--text-muted)', marginLeft: 8, fontSize: '.75rem' }}>
                  (URL pública: /<strong>{form.slug || 'slug-da-empresa'}</strong>)
                </span>
              </label>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ color: 'var(--text-muted)', fontSize: '.85rem', whiteSpace: 'nowrap' }}>/</span>
                <input className="form-control" value={form.slug}
                  onChange={e => F('slug', e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, '-').replace(/--+/g, '-'))}
                  placeholder="nome-da-empresa" />
              </div>
              <span style={{ fontSize: '.72rem', color: 'var(--text-muted)', marginTop: 2 }}>
                Apenas letras minúsculas, números e hífens. Preenchido automaticamente ao criar.
              </span>
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Logo</label>
            <div className="upload-area" onClick={() => document.getElementById('logo-input').click()}>
              {logoFile
                ? <img src={URL.createObjectURL(logoFile)} alt="Logo" />
                : editing?.logo_url
                  ? <img src={`${API}${editing.logo_url}`} alt="Logo" />
                  : <div><Icon name="image" size={24} /><p style={{ marginTop: '8px', color: 'var(--text-muted)', fontSize: '.85rem' }}>Clique para selecionar imagem</p></div>
              }
            </div>
            <input id="logo-input" type="file" accept="image/*" hidden onChange={e => setLogoFile(e.target.files[0])} />
          </div>

          {!editing && (
            <>
              <h4 style={{ color: 'var(--text-muted)', fontSize: '.8rem', textTransform: 'uppercase', letterSpacing: 1, marginTop: '8px' }}>Usuário Admin da Empresa</h4>
              <div className="form-grid">
                <div className="form-group">
                  <label className="form-label">Nome do Admin</label>
                  <input className="form-control" value={form.nome_admin} onChange={e => F('nome_admin', e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="form-label">Email do Admin</label>
                  <input className="form-control" type="email" value={form.email_admin} onChange={e => F('email_admin', e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="form-label">Senha do Admin</label>
                  <input className="form-control" type="password" value={form.senha_admin} onChange={e => F('senha_admin', e.target.value)} />
                </div>
              </div>
            </>
          )}
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={() => setModal(false)}>Cancelar</button>
          <button className="btn btn-primary" onClick={salvar} disabled={saving}>
            {saving ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </Modal>
    </div>
  );
}
